<template>
  <div class="personal-page">
    <!--img src="/images/yanfei.jpg" alt="Yanfei Liu Photo" class="staff-photo" /-->
    <div class="personal-details">
      <h2>Our Research and Development Focus Areas</h2>
      <p><strong>1. Cognitive Architecture Research and Development</strong></p>
      <p>We employ computational methods to study human cognition and develop computational cognitive architecture that simulate human-like cognitive processes. Human cognition research is a grand and ambitious undertaking. By constructing cognitive systems, we aim to replicate human cognitive processes through software. Our core work includes designing cognitive architectures and conceptualizing cognitive mechanisms.</p>
      <!--ul>
        <li>Languages: Mandarin (native), English (fluent)</li>
        <li>Hobbies: Chinese handwriting, hiking, table tennis</li>
      </ul-->
      <p><strong>2. Cognitive Modeling and Applied Development</strong></p>
      <p>Building upon our cognitive architecture, we use cognitive modeling to address practical challenges in various engineering fields:</p>
      <ul>
        <li><b>Task Optimization</b>: By analyzing cognitive processes, we study mental workload in complex tasks, enabling us to optimize task designs for greater efficiency and effectiveness.</li>
        <li><b>Cognitive Characteristics Assessment</b>: Through cognitive process simulation, we examine the relationship between human cognitive traits and the demands of complex tasks. This allows us to evaluate cognitive traits, assess their impact on work performance, and provide insights for task planning and personnel selection.</li>
        <li><b>Model Application</b>: We construct cognitive models and apply them in areas such as industrial control, robotics, and digital human development. By modeling expert knowledge and experience, we enhance applications in these domains.</li>
      </ul>
      <p><strong>3. Enterprise Application and Design of Computational Technologies</strong></p>
      <p>We support enterprises in leveraging computational technologies through:</p>
      <ul>
        <li><b>Enterprise Informatization</b>: Planning and building foundational platforms for enterprise information systems.</li>
        <li><b>Technology Development</b>: Developing enterprise solutions, including domain-specific applications of large language models and information systems.</li>
        <li><b>Human Factors Engineering</b>: Investigating specific human factors challenges faced by enterprises.</li>
      </ul>
      <h2>We warmly welcome collaborations and exchanges!</h2>
    </div>
  </div>
</template>

<style>
.staff-page {
  /* Add styles for the staff page */
  /*
我们开展以下领域的研究与开发工作：
 
 认知体系研究与开发：使用计算方法开展人的认知研究，开发仿真人类认知的计算认知系统。人的认知研究是一项宏伟而巨大的工程，通过构建认知体系试图使用软件仿真人类认知过程。建构认知架构、构思认知机制等是主要工作。
 
 认知建模及应用开发：基于认知体系通过认知建模方法试图解决工程领域的实际问题：1.通过对认知过程的展开，研究复杂任务的脑力负荷，从而优化复杂任务、实现任务设计优化；2.通过认知过程仿真，研究人的认知特性及其与复杂任务特点之间的关系、认知特性对工作绩效的影响等，实现认知特性评估，为任务规划、特定任务人员选拔提供依据；3.构建认知模型并应用于工业控制、机器人应用及数字人开发等，把专家知识和经验模型化。
 
 计算技术的企业应用与设计开发：1.企业信息化项目（如信息化平台建设等）规划及平台基础设施构建；2.企业信息化项目（如企业信息化系统、语言大模型在领域应用等）开发；3.企业具体人因工程问题研究。
 
 热忱欢迎合作交流！
  */
}
</style>